import { FormFields, FormValidationSchema } from '@/common/interfaces';

export enum CloudflareAccountsFormInputs {
  Email = 'email',
  Password = 'password',
  Provider = 'provider',
  ApiKey = 'apiKey',
}

export type CloudflareAccountsFormFields = FormFields<typeof CloudflareAccountsFormInputs>;

export type CloudflareAccountsFormValidationSchema = FormValidationSchema<CloudflareAccountsFormFields>;
